<av-card [@slideFromRight]="true" *ngIf="isAssistantOpen()">
  <av-card-header (close)="dismiss()"></av-card-header>
  <av-card-body size="sm">
    <av-card-row *ngFor="let s of snapshots(); trackBy: trackByFn">
      <av-vision [snapshot]="s"></av-vision>
    </av-card-row>
  </av-card-body>
</av-card>
